import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import {
  getMonitorProviderUsers,
  getMonitorStock,
} from "store/monitor-dashboard/monitor-dashboard-action"
import { monitorDashboardAction } from "store/monitor-dashboard/monitor-dashboard-slice"
import { isObject } from "lodash"

const MonitorStockFilter = ({
  onSubmit,
  onCategoryChange,
  provStockLoading,
  getSearchData,
  onAdvancedSearchHandler,
}) => {
  // fetch ips
  const ips = useSelector(state => state.monitorDashboard.MonitorIps)
  // fetch items
  const items = useSelector(state => state.monitorDashboard.MonitorItems)
  // fetch provider users
  const provider_users = useSelector(
    state => state.monitorDashboard.monitorProviderUsers
  )

  // fetch categories
  const categories = useSelector(
    state => state.monitorDashboard.MonitorItemCategoires
  )

  // fetch fund codes
  const fundCodes = useSelector(
    state => state.monitorDashboard.monitorFundCodes
  )

  // fetch shipments
  const shipments = useSelector(
    state => state.monitorDashboard.monitorShipments
  )

  // filter items based select box need
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const dispatch = useDispatch()
  const fromdateFlatpicker = useRef(null)
  const todateFlatpicker = useRef(null)
  const [Ips, setIps] = useState(null)
  const [providerUser, setProviderUser] = useState(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batchNumber, setBatchNumber] = useState("")
  const [fundCode, setFundCode] = useState(null)
  const [waybillNumber, setWaybillNumber] = useState("")
  const [shipment, setShipment] = useState(null)
  const [receiptType, setReceiptType] = useState(null)
  const [distributionType, setDistributionType] = useState(null)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)

  const handleSubmit = () => {
    let searchs = {}
    searchs.providerIP = isObject(Ips) ? Ips.value : null
    searchs.providerUser = isObject(providerUser) ? providerUser.value : null
    searchs.category = category ? category.value : null
    searchs.categoryName = category ? category.label : null
    if (item) {
      searchs.item = item.map(ite => (ite.value ? ite.value : ite))
    }
    searchs.batchNumber = batchNumber
    searchs.fundCode = isObject(fundCode) ? fundCode.value : null
    searchs.waybillNumber = waybillNumber
    searchs.shipment = isObject(shipment) ? shipment.value : null
    if (receiptType) {
      searchs.receiptType = receiptType.map(rt => (rt.value ? rt.value : rt))
    }
    if (distributionType) {
      searchs.distributionType = distributionType.map(dt => (dt.value ? dt.value : dt))
    }
    searchs.from = fromDate
    searchs.to = toDate
    onSubmit(searchs)
    onAdvancedSearchHandler(searchs)
    getSearchData(searchs)
  }

  // store ips via select box and get all provider users based ip id
  const IpsChangeHandler = ip => {
    dispatch(getMonitorProviderUsers(ip.value))
    setIps(ip)
  }

  // store provider user from select box
  const onProviderUserChangeHandler = value => {
    setProviderUser(value)
  }

  // store item category and call onCategory change to fetch new items based category
  const onCategoryChangeHandler = cate => {
    onCategoryChange(cate.value)
    setCategory(cate)
  }

  // store multiple items based we selected
  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    fromdateFlatpicker.current.flatpickr.clear()
    todateFlatpicker.current.flatpickr.clear()
    dispatch(monitorDashboardAction.resetMonitorProviderUsers())
    setIps(null)
    setProviderUser(null)
    setCategory(null)
    setItem(null)
    setBatchNumber("")
    setFundCode(null)
    setWaybillNumber("")
    setShipment(null)
    setReceiptType(null)
    setDistributionType(null)
    setFromDate(null)
    setToDate(null)
    getSearchData({})
    onSubmit({})
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Provider IPs</Label>
            {ips?.data && (
              <Select
                placeholder="All IPs"
                options={[{ value: "all", label: "All" }, ...ips?.data]}
                value={Ips}
                onChange={IpsChangeHandler}
              />
            )}
          </Col>

          <Col>
            <Label className="form-label">Provider Users</Label>
            {provider_users?.data && (
              <Select
                options={[
                  { value: "all", label: "All" },
                  ...provider_users?.data,
                ]}
                value={providerUser}
                onChange={onProviderUserChangeHandler}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Label className="form-label">Item Categories</Label>
        {categories?.data && (
          <Select
            placeholder="All Categories"
            options={[{ value: "all", label: "All" }, ...categories?.data]}
            value={category}
            onChange={onCategoryChangeHandler}
          />
        )}
      </div>

      {filteredItems && (
        <div className="mb-3">
          <Label className="form-label">Items</Label>
          <Select
            isMulti={true}
            options={[{ value: "all", label: "All" }, ...filteredItems]}
            value={item}
            onChange={onItemChangeHandler}
          />
        </div>
      )}
      <div className="mb-3">
        <Label className="form-label">Batch Number</Label>
        <Input
          name="name"
          value={batchNumber}
          onChange={value => {
            setBatchNumber(value.target.value)
          }}
          placeholder="Name"
          type="text"
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Fund Code</Label>
        {fundCodes?.data && (
          <Select
            placeholder="All Fund Codes"
            options={[{ value: "all", label: "All" }, ...fundCodes?.data]}
            value={fundCode}
            onChange={setFundCode}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Waybill Number</Label>
        <Input
          name="waybillNumber"
          value={waybillNumber}
          onChange={value => {
            setWaybillNumber(value.target.value)
          }}
          placeholder="Waybill Number"
          type="text"
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Shipment</Label>
        {shipments?.data && (
          <Select
            placeholder="All Shipments"
            options={[{ value: "all", label: "All" }, ...shipments?.data]}
            value={shipment}
            onChange={setShipment}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Receipt Types</Label>
        <Select
          isMulti={true}
          placeholder="All Receipt Types"
          options={[
            { value: "all", label: "All" },
            { value: "Receipts", label: "Receipts" },
            { value: "Other Source", label: "Other Source" },
            { value: "Opening Balance", label: "Opening Balance" },
          ]}
          value={receiptType}
          onChange={setReceiptType}
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Distribution Types</Label>
        <Select
          isMulti={true}
          placeholder="All Distribution Types"
          options={[
            { value: "all", label: "All" },
            { value: "Distribution", label: "Distribution" },
            { value: "Exchange", label: "Exchange" },
            { value: "Transfer", label: "Transfer" },
          ]}
          value={distributionType}
          onChange={setDistributionType}
        />
      </div>

      <div className="mb-3 ">
        <Label className="form-label">From Date</Label>
        <Flatpickr
          ref={fromdateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setFromDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
        <br />
        <Label className="form-label">To Date</Label>
        <Flatpickr
          ref={todateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setToDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-2">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={provStockLoading}
        >
          {provStockLoading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default MonitorStockFilter
